import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PatientService } from 'src/app/services/patient/patient.service';
import { CreationPatient } from 'src/app/utils/interfaces/new/creation-patient.interface';
import { environment } from 'src/environments/environment';

interface PatientInfosForm {
  nomNaissance: string;
  prenomNaissance: string;
  dateNaissance: string;
  sexe: string;
  cpNaissance: string;
  ins: string;
  insKey: string;
  oid: string;
  isInsOk: boolean;
  isDomaineConfiance: boolean;
  prenomsNaissance: string;
}

@Component({
  selector: 'app-create-patient-from-cda',
  templateUrl: './create-patient-from-cda.component.html',
  styleUrls: [
    './create-patient-from-cda.component.scss',
    '../modal.fragment.scss'
  ]
})
export class CreatePatientFromCdaComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @Output() public closeEmitter = new EventEmitter<string | undefined>();

  isInsOk: boolean;
  isDomaineConfiance: boolean;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target) && !this.isLoading) {
      this.closeModal();
    }
  }

  public formGroup: FormGroup;
  public insType: string;
  public isLoading = false;

  constructor(
    private _formBuilder: FormBuilder,
    private _patientSrv: PatientService
  ) { }

  ngOnInit(): void {
  }

  public initForm(infos: PatientInfosForm): void {
    this.isInsOk = infos.isInsOk;
    this.isDomaineConfiance = infos.isDomaineConfiance;

    this.formGroup = this._formBuilder.group({
      nomNaissance: [infos.nomNaissance, Validators.required],
      prenomNaissance: [infos.prenomNaissance, Validators.required],
      dateNaissance: [infos.dateNaissance, Validators.required],
      sexe: [infos.sexe, Validators.required],
      cpNaissance: [infos.cpNaissance, Validators.required],
      ins: [infos.ins, Validators.required],
      insKey: [infos.insKey, Validators.required],
      insAndKey: [`${infos.ins}${infos.insKey}`, Validators.required],
      oid: [infos.oid, Validators.required],
      prenomsNaissance: [infos.prenomsNaissance],
    });

    switch (infos.oid) {
      case '1.2.250.1.213.1.4.8':
        this.insType = 'INS-NIR';
        break;
      case '1.2.250.1.213.1.4.9':
        this.insType = 'INS-NIA';
        break;
      case '1.2.250.1.213.1.4.10':
        this.insType = 'INS-NIR de test';
        break;
      case '1.2.250.1.213.1.4.11':
        this.insType = 'INS-NIR de démonstration';
        break;
    }
  }

  public async onSubmit(): Promise<void> {

    const dateNaissance = this.formGroup.get('dateNaissance').value;
    const nomNaissance = this.formGroup.get('nomNaissance').value;
    const nom = this.formGroup.get('nomNaissance').value;
    const nomUsage = this.formGroup.get('nomNaissance').value;
    const prenom = this.formGroup.get('prenomNaissance').value;
    const prenomUsage = this.formGroup.get('prenomNaissance').value;
    const sexe = this.formGroup.get('sexe').value;
    const cpNaissance = this.formGroup.get('cpNaissance').value;
    const ins = this.formGroup.get('ins').value;
    const insKey = this.formGroup.get('insKey').value;
    const oid = this.formGroup.get('oid').value;
    const prenomsNaissance = this.formGroup.get('prenomsNaissance').value;

    const currentProfilStr = localStorage.getItem('currentProfil');
    if (currentProfilStr && currentProfilStr !== '') {
      const currentProfil = JSON.parse(currentProfilStr);
      if (currentProfil.id && currentProfil.id !== '') {
        const patient: CreationPatient = {
          dateNaissance,
          nomNaissance,
          nom,
          nomUsage,
          prenom,
          prenomUsage,
          sexe,
          cpNaissance: cpNaissance && cpNaissance !== '' ? cpNaissance : undefined,
          ins: ins || undefined,
          insKey: insKey || undefined,
          oid: oid || undefined,
          idResponsableDossier: currentProfil.id,
          prenomsNaissance,
        };

        try {
          this.isLoading = true;
          const patientId = await this._patientSrv.createPatient(patient);
          this.isLoading = false;
          this.closeModal(patientId);
        } catch (e) {
        }
      } else {
        this.closeModal();
      }
    }
  }

  public closeModal(patientId?: string): void {
    if (patientId) {
      this.closeEmitter.emit(patientId);
    } else {
      this.closeEmitter.emit();
    }
  }

}
